/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeformsentatlabel4Inputs */

const en_outcomeformsentatlabel4 = /** @type {(inputs: Outcomeformsentatlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When did you send it?`)
};

const pt_outcomeformsentatlabel4 = /** @type {(inputs: Outcomeformsentatlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando enviou a carta?`)
};

/**
* | output |
* | --- |
* | "When did you send it?" |
*
* @param {Outcomeformsentatlabel4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsentatlabel4 = /** @type {((inputs?: Outcomeformsentatlabel4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsentatlabel4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsentatlabel4(inputs)
	return pt_outcomeformsentatlabel4(inputs)
});
export { outcomeformsentatlabel4 as "outcomeFormSentAtLabel" }